module.exports = __webpack_public_path__ + "img/logo-color.6ffb5b84.png";